import { CopyIcon } from "@radix-ui/react-icons";
import { Button } from "@radix-ui/themes";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

type CopyToClipboardButtonProps = {
  textToCopy: string;
};

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  textToCopy,
}) => {
  const handleCopy = () => {
    if (!textToCopy) return;

    const success = copy(textToCopy);
    if (success) {
      toast.success("Kopiert!");
    } else {
      toast.error("Fehler beim Kopieren");
    }
  };

  return (
    <Button
      size="1"
      variant="ghost"
      onClick={handleCopy}
      style={{
        minWidth: "auto",
        padding: "4px",
      }}
    >
      <CopyIcon />
    </Button>
  );
};
